module.exports = __webpack_public_path__ + "img/percent-icon.651ddfa4.svg";